<template>
  <div>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="controlBoxInspections">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.exportControlBoxInspection.open(0)">
          导出
        </el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="查询">
            <el-input v-model.trim="filter.filter" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="billNO" align="center" label="编号"/>
      <el-table-column prop="barcode" align="center" label="条码"/>
      <el-table-column prop="cabinetType" align="center" label="功率"/>
      <el-table-column prop="inspectionTypeName" align="center" label="控制柜"/>
      <el-table-column prop="createTime" align="center" label="扫描时间"/>
      <el-table-column prop="note" align="center" label="结果"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="120px">
        <template slot-scope="scope">
          <el-button type="primary" @click="goto(scope.row.pkid)">查看详情</el-button>
          <!--          <el-button type="primary" @click="$refs.editPage.open(scope.row.pkid)">编辑</el-button>-->
          <!--          <el-button type="danger" @click="deleteRow(scope.row)">删除</el-button>-->
        </template>
      </el-table-column>
    </vm-table>
    <export-control-box-inspection ref="exportControlBoxInspection"/>
    <!--    <control-box-inspection-detail/>-->
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import ExportControlBoxInspection from "@/views/scheduling/ControlBoxInspection/exportControlBoxInspection";
  // import ControlBoxInspectionDetail from "@/views/scheduling/ControlBoxInspection/ControlBoxInspectionDetail";

  export default {
    name: "ControlBoxInspection",
    components: {ExportControlBoxInspection, VmTable, VmSearch},
    data() {
      return {
        constant,
        // addAuth: this.$auth(252),
        // editAuth: this.$auth(253),
        // delAuth: this.$auth(254),
        ids: [],
        filter: {
          filter:"",
        },
      };
    },
    mounted() {
      this.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      goto(id) {
        this.$router.push({
          path: "/controlBoxInspection",
          query: {
            pkid: id,
          },
        });
      },
    },
  };
</script>
<style scoped>
</style>
